import * as React from "react";
import { RenderSettingControl } from "./setting-control-renderer";

export const RenderSettingPanel = ({ settingSection, sectionKey, parentSectionKey }) => {
    if (settingSection === null)
        return null;
    const panelPath = `${parentSectionKey}.${sectionKey}`
    const sectionKeys = Object.keys(settingSection).filter(key => key !== "label" && key !== "studySessionType" && key !== "studyDeviceType");

    if (sectionKeys.length === 0 || sectionKeys.every(key => settingSection[key]?.editable === false))
        return null;

    return (
        <div className="panel panel-default">
            <div className="panel-heading">
                <h3 className="panel-title">{settingSection?.label}</h3>
            </div>
            <div className="panel-body">
                {
                    sectionKeys.map((sectionKey) => {
                        return (
                            <RenderSettingControl
                                key={`${panelPath}.${sectionKey}`}
                                settingDefinition={settingSection[sectionKey]}
                                settingKey={sectionKey}
                                parentSectionKey={panelPath} />
                        )
                    })
                }
            </div>
        </div>
    )
}
